import React, { useState, useEffect } from "react";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import Profile from "./Profile";
import EmployeeManagement from "./EmployeeManagement";
import FeedbackManagement from "./FeedbackManagement";
import AddEmployee from "./AddEmployee";
import IncidentManagement from "./IncidentManagement";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import MondelezLogo from "./assets/mondelez-logo.png";
import SodexoLogo from "./assets/sodexo-logo.png";


function App() {
  const [admin, setAdmin] = useState(() => {
    const saved = sessionStorage.getItem("admin");
    return saved ? JSON.parse(saved) : null;
  });

  const [page, setPage] = useState("login");
  const [forgotStage, setForgotStage] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  // Set default page based on login
  useEffect(() => {
    if (admin) setPage("employee");
    else setPage("login");
  }, [admin]);

  // Toggle sidebar visibility
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  // Disable body scroll when sidebar is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  // Logout function
  const logout = () => {
    setAdmin(null);
    sessionStorage.removeItem("admin");
    setPage("login");
    setForgotStage(null);
  };

  // Authentication pages
  if (!admin) {
    if (forgotStage === "forgot") {
      return (
        <ForgotPassword
          onBack={() => setForgotStage(null)}
          onReset={() => setForgotStage("reset")}
        />
      );
    }
    if (forgotStage === "reset") {
      return <ResetPassword onBack={() => setForgotStage(null)} />;
    }
    return (
      <Login onLogin={setAdmin} onForgot={() => setForgotStage("forgot")} />
    );
  }

  return (
    <div className="app-wrapper">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg custom-navbar shadow-sm mb-0 sticky-top">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            {/* Navbar toggler */}
            <button
              className="navbar-toggler me-2 border-0"
              type="button"
              aria-controls="navbarNav"
              aria-expanded={menuOpen ? "true" : "false"}
              aria-label="Toggle navigation"
              onClick={toggleMenu}
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Brand */}
            {/* <a className="navbar-brand fw-bold text-white m-0" href="#">
              Mondelez Admin Panel
            </a> */}
            <a
  className="navbar-brand d-flex align-items-center fw-bold text-white m-0"
  href="/"
  style={{ gap: "12px" }} // flex gap between all children
>
  <img src={MondelezLogo} alt="Logo 1" style={{ height: "30px", width: "auto" }} />
  <img src={SodexoLogo} alt="Logo 2" style={{ height: "30px", width: "auto" }} />
</a>

          </div>

          {/* Sidebar menu */}
          <div
            className={`offcanvas-collapse ${menuOpen ? "show" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav d-flex align-items-center gap-2 ms-auto">
              <li className="nav-item">
                <button
                  className={`btn btn-outline-light${
                    page === "employee" ? " active" : ""
                  }`}
                  onClick={() => {
                    setPage("employee");
                    closeMenu();
                  }}
                >
                  Employees
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`btn btn-outline-light${
                    page === "feedback" ? " active" : ""
                  }`}
                  onClick={() => {
                    setPage("feedback");
                    closeMenu();
                  }}
                >
                  Feedback
                </button>
              </li>
              {/* <li className="nav-item">
                <button
                  className={`btn btn-outline-light${
                    page === "profile" ? " active" : ""
                  }`}
                  onClick={() => {
                    setPage("profile");
                    closeMenu();
                  }}
                >
                  Profile
                </button>
              </li> */}
              <li className="nav-item">
                <button
                  className={`btn btn-outline-light${
                    page === "incident" ? " active" : ""
                  }`}
                  onClick={() => {
                    setPage("incident");
                    closeMenu();
                  }}
                >
                  Incidents
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    logout();
                    closeMenu();
                  }}
                >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Main content */}
      <main
        className="container app-content mt-0"
        style={page === "profile" ? { padding: 0 } : {}}
      >
        {page === "employee" && (
          <EmployeeManagement onAdd={() => setPage("add-employee")} />
        )}
        {page === "add-employee" && (
          <AddEmployee onBack={() => setPage("employee")} />
        )}
        {page === "feedback" && <FeedbackManagement />}
        {/* {page === "profile" && <Profile admin={admin} />} */}
        {page === "incident" && <IncidentManagement />}
      </main>
    </div>
  );
}

export default App;
